// tslint:disable
export enum EnrollmentEligibility {
    /**
     * @description didn't even try
     */
    Undetermined = 0,
    /**
     * @description yes
     */
    Passed = 1,
    /**
     * @description no
     */
    Failed = 2,
}
(EnrollmentEligibility as any)['UNDETERMINED'] = 0;
(EnrollmentEligibility as any)['PASSED'] = 1;
(EnrollmentEligibility as any)['FAILED'] = 2;
